﻿$.fn.dxCtrlEmailPrevisualisationAcidClientLst = function custom_dxCtrlEmailPrevisualisationAcidClientLst(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlemailprevisualisationacidclientlst dx-ctrl");
        this.createInstance(new cdxCtrlEmailPrevisualisationAcidClientLst(this, option));
    }
    return this;
}

window.cdxCtrlEmailPrevisualisationAcidClientLst = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivNoDataText = null
    var lstDx = []
    function mConstruit() {
        container.empty()
        lstDx = []
        container.css({
            "position": "relative",
            "text-align": "center"
        })
        option.data.forEach(function (item) {
            lstDx.push($("<div style='display:inline-block;margin:5px;'/>").appendTo(container).dxCtrlEmailPrevisualisationAcidClient({
                bddCtrl: option.bddCtrl,
                data: item,
                lstImg: option.lstImg,
                zoom: option.zoom,
                onReloadImage:option.onReloadImage
            }).dxCtrlEmailPrevisualisationAcidClient("instance"))
        })
        $DivNoDataText = $("<div style='text-align:center;padding:20px;'>Aucune prévisualisation sélectionnée</div>").appendTo(container)
        Me.mShowHideNoDataText()
    }

    this.mShowHideNoDataText = function () {
        if (option.data.filter(function (o) { return o.checked }).length == 0) { $DivNoDataText.slideDown() }
        else { $DivNoDataText.slideUp() }
    }

    this.mChangeZoom = function (zoom) {
        option.zoom = zoom
        lstDx.forEach(function (dx) { dx.mChangeZoom(zoom) })
    }

    this.mChangeCrop = function (crop) {
        option.cropped = crop
        lstDx.forEach(function (dx) { dx.mChangeCrop(crop) })
    }

    this.element = function () { return container }

    mConstruit();
}